// Imports
import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import Input from '../../../../../../shareables/foundation/front-end/components/forms/fields/input';
import { useAppSelector } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import APIForm, { APIFormOptions } from '../../../../../../shareables/integrations/api/components/form';
import {
	PostPasswordParameters,
	PostPasswordResponse,
} from '../../../../../../shareables/types/api/main/self/password/post';
import PageTitle from '../../shared-components/page-title';


// Styled components
const Note = styled.p`
	line-height: 1.3125rem;
	margin-bottom: 1.3rem;
`;


// Define the accepted props
interface Props {
	storybookSecret?: string;
}


// Function component
const NewPassword: React.FC<Props> = ({ storybookSecret }) => {
	// Use React Router functionality
	const [searchParams] = useSearchParams();
	const location = useLocation();
	
	
	// Use Redux functionality
	const signedIn = useAppSelector((state) => state.common.user.signedIn);
	
	
	// Grab secret from search params
	const secret = storybookSecret !== undefined ? storybookSecret : (searchParams.get('s') ?? '');
	
	
	// Build form options
	const formOptions: APIFormOptions<PostPasswordParameters, undefined, PostPasswordResponse> = {
		action: 'POST',
		uri: '/self/password',
		submitButton: {
			text: 'Save',
			disabled: signedIn,
		},
		recoverState: false,
		extraParameters: { secret },
	};
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle>New password</PageTitle>
			
			{!secret ? (
				<Note>This link appears to be invalid. Please check your email for the original invitation.</Note>
			) : (
				<React.Fragment>
					{signedIn && (
						<Note>
							You’re currently signed in. Please{' '}
							<a
								href={`https://${window.location.hostname}/oauth/sign-out?redirect-uri=${encodeURIComponent(
									`${location.pathname}${location.search}`
								)}`}
							>
								sign out
							</a>{' '}
							and then visit this link again to set your password.
						</Note>
					)}
					
					<APIForm
						options={formOptions}
						onCompletion={(json) => {
							window.location.href = `/oauth/set-session?accessToken=${json.response.accessToken}&refreshToken=${json.response.refreshToken}&redirect-uri=${encodeURIComponent('/')}`;
						}}
					>
						<Input
							name='password'
							type='password'
							label='New password'
							note='(Case sensitive)'
							placeholder='••••••••••'
							data-private
							showStrength
							required
							disabled={signedIn}
						/>
					</APIForm>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default NewPassword;
